module.exports = __webpack_public_path__ + "img/btn-icon-2.ec81a393.png";